import { render, staticRenderFns } from "./b2bcontractquota.vue?vue&type=template&id=d7ac0b40&scoped=true&"
import script from "./b2bcontractquota.vue?vue&type=script&lang=js&"
export * from "./b2bcontractquota.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./b2bcontractquota.vue?vue&type=style&index=1&id=d7ac0b40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ac0b40",
  null
  
)

export default component.exports